export const TemplateScopeMapping = {
  user: { title: 'Personal', icon: 'bi-person-fill', color: 'zocks-bg-color-warning' },
  account: { title: 'Account', icon: 'bi-people-fill', color: 'zocks-bg-color-success-background' },
  enterprise: { title: 'Enterprise', icon: 'bi-building', color: 'zocks-bg-color-cyan' },
  system: { title: 'System', icon: 'bi-rocket', color: 'zocks-bg-color-primary-light' },
}
